import clsx from "clsx";
import { useWsStatusStore } from "../api/ws";
import { useAuthStore } from "../auth/authStore";

export function StatusBar() {
  const status = useWsStatusStore((s) => s.status);
  const lastSeq = useWsStatusStore((s) => s.lastSeq);
  const lastTs = useWsStatusStore((s) => s.lastTs);
  const err = useWsStatusStore((s) => s.error);
  const user = useAuthStore((s) => s.user?.username);

  const color =
    status === "connected" ? "text-good" : status === "connecting" ? "text-warn" : "text-muted";

  return (
    <footer className="flex h-[22px] min-h-[22px] items-center gap-4 border-t border-border bg-panel px-2 text-[10px] uppercase tracking-wide text-muted">
      <span className={clsx("font-medium", color)}>WS: {status}</span>
      {lastSeq > 0 && <span>seq {lastSeq}</span>}
      {lastTs && <span className="truncate">ts {lastTs}</span>}
      {err && <span className="text-bad truncate">{err}</span>}
      <span className="hidden shrink-0 text-muted sm:inline" title="REST failures render as red alert banners above the workspace; this line is not a live error indicator.">
        Page alerts show HTTP/API errors in context
      </span>
      <span className="ml-auto">{user}</span>
    </footer>
  );
}
